<div class="box">
    <div class="box-header">
        <h3 class="box-title"> Monthly New Customer </h3>
    </div>

    <div class="box-body no-padding std-table-height scroll">
        <table class="mobileTable table table-striped">

            <tr>
                <th>Month</th>
                <th *ngFor="let item of CustomerCounts"> {{ item.MonthName }} </th>
            </tr>

            <tr >
                <th> Male </th>
                <td *ngFor="let item of CustomerCounts"> {{ item.Male }} </td>
            </tr>

            <tr>
                <th> Female </th>
                <td  *ngFor="let item of CustomerCounts">{{ item.Female }}</td>
            </tr>

        </table>
    </div>
</div>
